"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// clang-format on
var NavigationEvent;
(function (NavigationEvent) {
    NavigationEvent[NavigationEvent["PREV"] = 0] = "PREV";
    NavigationEvent[NavigationEvent["NEXT"] = 1] = "NEXT";
})(NavigationEvent = exports.NavigationEvent || (exports.NavigationEvent = {}));
//# sourceMappingURL=datepicker-view-model.js.map


//////////////////
// WEBPACK FOOTER
// ./temp/datepicker/datepicker-view-model.js
// module id = 44
// module chunks = 0